import { Typography } from "@mui/material";
import * as Sentry from "@sentry/react";
import { type FC, useEffect } from "react";
import { isRouteErrorResponse } from "react-router";

import { NotFoundPage } from "~/components/NotFoundPage";
import { ServiceUnavailablePage } from "~/components/ServiceUnavailablePage";
import {
  getRouteErrorKind,
  shouldReportRouteError,
} from "~/utils/routeErrorKind";

import styles from "./ErrorBoundary.module.scss";

export const ErrorBoundary: FC<{ error: unknown }> = ({ error }) => {
  useEffect(() => {
    if (!shouldReportRouteError(error)) return;
    Sentry.captureException(error);
  }, [error]);

  const kind = getRouteErrorKind(error);

  if (kind === "notFound") {
    return <NotFoundPage />;
  }

  if (kind === "serviceUnavailable") {
    return <ServiceUnavailablePage />;
  }

  const message =
    error instanceof Error
      ? error.message
      : isRouteErrorResponse(error)
        ? error.statusText
        : "Something went wrong";

  return (
    <main className={styles.root}>
      <Typography variant="h3" component="h1" sx={{
        fontWeight: 600
      }}>
        Unexpected error
      </Typography>
      <Typography
        align="center"
        sx={{
          paddingLeft: 3,
          paddingRight: 3
        }}>
        {message}
      </Typography>
    </main>
  );
};
